// For Export File
import { MessageBox, Message } from "element-ui";
import {
  postFulfillmentExportFile,
  postFulfillmentExtrainfoSheetExport
} from "@/services/fulfillment-api";
import postDownload from "../utils/download";
export default {
  data() {
    return {
      exportTypeList: ["1"],
      exportDialogVisible: false,
      /**
       * 全部导出：all
       * 部分导出：part
       */
      exportType: null
    };
  },
  methods: {
    handleExportDialogClose() {
      // reset
      this.exportType = null;
    },
    // 导出
    handleExport(type) {
      if (type === "excel") {
        this.exportType = "part";
        this.exportDialogVisible = true;
      } else if (type === "all_excel") {
        this.exportType = "all";
        this.exportDialogVisible = true;
      } else if (type === "pdf") {
        this.exportPdf();
      } else if (type === "regained") {
        this.exportZip();
      }
    },
    // 导出 excel
    async exportExcel() {
      if (!this.exportType) {
        throw new Error("[func exportExcel] no exportType");
      }

      // 必须选择原因
      if (!this.exportTypeList.length) {
        Message.warning(this.$t("ffm_pls_select_export_tab"));
        return;
      }
      try {
        let resp;
        if (this.exportType === "part") {
          resp = await postFulfillmentExportFile({
            operation_id_list: this.exportTypeList.map(Number),
            order_base_id_list: this.selectedIds,
            export_type: 1
          });
          // done jacob:修改文件访问方式
          postDownload("result.xlsx", resp);
        } else if (this.exportType === "all") {
          const getData = function(data) {
            const blackList = ["page", "limit"];
            let res = {};
            for (const [key, value] of Object.entries(data)) {
              if (blackList.includes(key) || !value) {
                continue;
              }
              res[key] = value;
            }
            return res;
          };
          let data = {
            ...getData(this.searchParamsSnap),
            operation_id_list: this.exportTypeList.map(Number)
          };
          resp = await postFulfillmentExtrainfoSheetExport(data);
          // done jacob:修改文件访问方式
          postDownload("result.xlsx", resp);
        }
        this.exportDialogVisible = false;
      } catch (e) {
        console.log("err:", e);
        Message.error(this.$t("ffm_export_failed"));
      }
    },
    // 导出pdf
    async exportPdf() {
      let selectedTypes = this.selectedItems.map(
        v => v.order_base_info.template_id
      );
      // 包含实体卡不能导出 PDF
      if (selectedTypes.includes(2)) {
        Message.warning(
          "The physical products is included in the selected orders, please re-select"
        );
        return;
      }
      await MessageBox.confirm(this.$t("ffm_confirm_export"), "Alert", {
        type: "info"
      });
      try {
        let resp = await postFulfillmentExportFile({
          order_base_id_list: this.selectedIds,
          export_type: 2
        });
        // done jacob:修改文件访问方式
        postDownload("result.pdf", resp);
      } catch (e) {
        Message.error(this.$t("ffm_export_failed"));
      }
    },
    // 导出压缩包
    async exportZip() {
      await MessageBox.confirm(this.$t("ffm_confirm_export"), "Alert", {
        type: "info"
      });
      try {
        let resp = await postFulfillmentExportFile({
          order_base_id_list: this.selectedIds,
          export_type: 3
        });
        // done jacob:修改文件访问方式
        postDownload("result.zip", resp);
      } catch (e) {
        Message.error(this.$t("ffm_export_failed"));
      }
    }
  }
};
